import { createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const styles = () => ({ breakpoints }: Theme) =>
  createStyles({
    removeStyles: {
      marginLeft: 70,
      [breakpoints.down('md')]: {
        marginLeft: -25,
      },
    },
    dontRemoveStyles: {
      marginTop: 30,
    },
  });

export default styles;
